import {pageInfo} from '../api';
import {plant} from '../../../../api'
import {Message} from 'element-ui';

const hikVehicleExit = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    }
  }
}
export default hikVehicleExit



// WEBPACK FOOTER //
// ./src/page/int/hikVehicleExit/store/hikVehicleExit.store.js